<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                this.messageDismissButton }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ this.messageConfirmButton }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="equipes" :mostrar-inativos="mostrarInativos" :loading="loadingtable" :default-multi-sort="defaultSort"
            :loading-text="$t('teams.loading')"

 cod-tabela="EQUIPES" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('teams.title')" :token="token" :items="equipesFiltradas" csv-title="equipes"
                    :pdf-title="$t('nav.registration.teams')" :pdf-headers="headers" pdf-filename="equipes" hide-search>
                    <template v-slot:extension>
                        <v-switch
                            v-model="mostrarInativos"
                            :label="$t('crudVeiculos.showInactive')"
                            class="ml-3 mr-4"
                            hide-details
                        ></v-switch>
                    </template>
                    <template v-slot:add>
                        <v-dialog v-model="dialog" max-width="100%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field v-model="editedItem.nome_equipe"
                                                        :label="$t('teams.fields.name')" :rules="[nomeEquipeRules]"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="3">
                                                    <v-switch v-model="editedItem.ativo" class="ma-2"
                                                        :label="$t('teams.fields.active')"></v-switch>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-textarea v-model="editedItem.descricao"
                                                        :label="$t('teams.fields.description')" rows="3"></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-autocomplete v-model="editedItem.id_empresa" :items="empresas"
                                                        item-text="razao_social" item-value="id_empresa" single-line auto
                                                        clearable :label="$t('teams.fields.company')"
                                                        :rules="[(v) => !!v || $t('teams.fields.company_required')]">
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-card style="margin-top: 15px;">
                                                        <v-card-title style="color: #4a4a4a;">{{ $t('teams.fields.manageUsers') }}</v-card-title>
                                                        <v-card-text>
                                                            <v-row>
                                                                <v-col cols="12" sm="6" md="12">
                                                                    <MultiplaEscolha ref="supervisorSelect" lazy
                                                                        get-url="getUsuarioslazy"
                                                                        text="displayText" value="id_usuario"
                                                                        :items="membrosSupervisor"
                                                                        :request-data="usuariosRequestData"
                                                                        :lazy-item-filter="filtroUsuariosSupervisor"
                                                                        :max-items="6"
                                                                        :label="$t('teams.fields.supervisor')"
                                                                        :hint="$t('teams.fields.supervisor_hint')" persistent-hint
                                                                        :selected-items.sync="supervisorSelected" />
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" sm="6" md="12">
                                                                    <MultiplaEscolha ref="dispatcherSelect" lazy
                                                                        get-url="getUsuarioslazy"
                                                                        text="displayText" value="id_usuario"
                                                                        :items="membrosCoordenador"
                                                                        :request-data="usuariosRequestData"
                                                                        :lazy-item-filter="filtroUsuariosCoordenador"
                                                                        :max-items="6"
                                                                        :label="$t('teams.fields.dispatcher')"
                                                                        :hint="$t('teams.fields.dispatcher_hint')" persistent-hint
                                                                        :selected-items.sync="dispatcherSelected" />
                                                                </v-col>
                                                            </v-row>
                                                            <v-row>
                                                                <v-col cols="12" sm="6" md="12">
                                                                    <MultiplaEscolha ref="usuariosSelect" lazy
                                                                        get-url="getUsuarioslazy"
                                                                        text="displayText" value="id_usuario"
                                                                        :items="membrosFuncionario"
                                                                        :request-data="usuariosRequestData"
                                                                        :lazy-item-filter="filtroUsuariosFuncionario"
                                                                        :max-items="6"
                                                                        :label="$t('teams.fields.users')"
                                                                        :hint="$t('teams.fields.users_hint')" persistent-hint
                                                                        :selected-items.sync="usuariosEquipe" />
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

    import apiController from "@/utils/apiController";
    import { validador } from "@/constants";
    import MerusDataTable from "./Tables/MerusDataTable.vue";
    import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
    import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";
    import EventBus from '../utils/eventBus';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        MultiplaEscolha
    },
    data: () => ({
    headers: [],
        equipes: [],
        mostrarInativos: false,
        empresas: [],
        usuariosEquipe: [],
        /** Membros ja associados, vindos do getusuariosporequipe. */
        membrosEquipe: [],
        supervisorSelected: [],
        dispatcherSelected: [],
        search: "",
        loadingtable: true,
        loadingUsuariosEquipe: false,
        tipoAlerta: "success",
        showAlert: false,
        mensagemAlerta: "",
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,

        authDialog: false,
        formValidado: true,
        dialog: false,
        sysError: null,
        editedIndex: -1,
        operacao: 0,
        payload: {},
        editedItem: {
            id_equipe: null,
            nome_equipe: null,
            descricao: null,
            id_empresa: null,
            ativo: true,
        },
        deletedItem: {
            id_equipe: null,
            nome_equipe: null,
            descricao: null,
            id_empresa: null,
            ativo: true,
        },
        defaultItem: {
            id_equipe: null,
            nome_equipe: null,
            descricao: null,
            id_empresa: null,
            ativo: true,
        },
    }),
    computed: {
        equipesFiltradas() {
            if (!this.mostrarInativos) {
                return this.equipes.filter((e) => e.ativo === true || e.ativo === 1);
            }
            return this.equipes;
        },
        formTitle() {
            return this.editedIndex === -1 ? this.$t('teams.dialog.create') : this.$t('teams.dialog.edit');
        },
        defaultSort() {
            return [
                { value: 'ativo_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } },
                { value: 'nome_equipe', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        messageConfirmButton() {
            return this.$t('button.confirm');
        },
        messageDismissButton() {
            return this.$t('button.dismiss');
        },
    nomeEquipeRules() {
            if (!validador(this.editedItem.nome_equipe, 1, 200, 1, 1)) {
                return this.$t('teams.fields.name_hint');
            } else {
                return true;
            }
        },
        /** Filtros enviados ao getusuarioslazy (empresa da equipe, sem passageiros). */
        usuariosRequestData() {
            return {
                id_empresa: this.editedItem.id_empresa != null && this.editedItem.id_empresa !== ''
                    ? this.editedItem.id_empresa
                    : null,
                excluirPassageiros: true,
            };
        },
        /**
         * Membros ja associados entram como itens estaticos do select lazy: assim o
         * rotulo aparece na abertura do dialogo, sem depender da pagina do lazy nem
         * de o conteudo do v-dialog ja estar montado.
         */
        membrosSupervisor() {
            return this.membrosPorTipo(1);
        },
        membrosCoordenador() {
            return this.membrosPorTipo(2);
        },
        membrosFuncionario() {
            return this.membrosPorTipo(0);
        },
        filtroUsuariosSupervisor() {
            return (items) => this.prepararUsuariosLazy(items, [
                this.dispatcherSelected,
                this.usuariosEquipe,
            ]);
        },
        filtroUsuariosCoordenador() {
            return (items) => this.prepararUsuariosLazy(items, [
                this.supervisorSelected,
                this.usuariosEquipe,
            ]);
        },
        filtroUsuariosFuncionario() {
            return (items) => this.prepararUsuariosLazy(items, [
                this.supervisorSelected,
                this.dispatcherSelected,
            ]);
        },
    },
    watch: {
        dialog(val) {
            if (val && this.editedIndex === -1) {
                this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
            }
        },
        empresas() {
            if (this.dialog && this.editedIndex === -1) {
                this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
            }
        },
        supervisorSelected(val) {
            this.removerUsuariosDeOutrasFuncoes(val, 'supervisor');
        },
        dispatcherSelected(val) {
            this.removerUsuariosDeOutrasFuncoes(val, 'coordenador');
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user")).id_usuario;
        this.token = sessionStorage.getItem("api");
        this.initialize();
        this.populaEmpresas();
    },
    methods: {

        applySingleEmpresaIfOnlyOption() {
            if (!this.dialog || this.editedIndex !== -1) {
                return;
            }
            if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
                return;
            }
            if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
                return;
            }
            this.editedItem.id_empresa = this.empresas[0].id_empresa;
        },
        initialize() {
            apiController.request(apiController.endpoints.getallEquipes, {
                onSuccess: (response) => {
                    this.equipes = response.data;
                    this.loadingtable = false;
                },
            });
        },
        removerUsuariosDeOutrasFuncoes(ids, funcaoOrigem) {
            if (!Array.isArray(ids) || ids.length === 0) {
                return;
            }
            const selecionados = new Set(ids);
            // O select mantem a propria selecao interna: alem do estado local,
            // e preciso empurrar a lista filtrada de volta para o componente.
            const remover = (campo, refName) => {
                const atual = this[campo] || [];
                const filtrado = atual.filter(id => !selecionados.has(id));
                if (filtrado.length === atual.length) {
                    return;
                }
                this[campo] = filtrado;
                const ref = this.$refs[refName];
                if (ref && typeof ref.setSelectedItems === 'function') {
                    ref.setSelectedItems(filtrado);
                }
            };
            if (funcaoOrigem === 'supervisor') {
                remover('dispatcherSelected', 'dispatcherSelect');
                remover('usuariosEquipe', 'usuariosSelect');
            } else if (funcaoOrigem === 'coordenador') {
                remover('usuariosEquipe', 'usuariosSelect');
            }
        },
        membrosPorTipo(tipo) {
            return (this.membrosEquipe || [])
                .filter((m) => m && Number(m.id_tipo_usuario) === tipo)
                .map((m) => ({ ...m, displayText: this.montarDisplayTextUsuario(m) }));
        },
        /** Rotulo exibido no select; a empresa so aparece quando a equipe nao filtra por empresa. */
        montarDisplayTextUsuario(usuario) {
            if (!usuario) {
                return '';
            }
            const base = `${usuario.nome_usuario || ''} (${usuario.login || ''})`;
            if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
                return base;
            }
            return usuario.razao_social ? `${base} - ${usuario.razao_social}` : base;
        },
        /**
         * Pos-processa a pagina vinda do getusuarioslazy: tira quem ja ocupa outra
         * funcao na equipe e monta o rotulo exibido.
         */
        prepararUsuariosLazy(items, outrasSelecoes) {
            const bloqueados = new Set();
            (outrasSelecoes || []).forEach((lista) => {
                (lista || []).forEach((id) => bloqueados.add(id));
            });
            return (Array.isArray(items) ? items : [])
                .filter((u) => u && !bloqueados.has(u.id_usuario))
                .map((u) => ({ ...u, displayText: this.montarDisplayTextUsuario(u) }));
        },
        /**
         * Semeia os selects com os membros ja associados (nome/login vem do proprio
         * getusuariosporequipe), sem esperar a lista completa de usuarios.
         */
        aplicarSelecaoUsuarios(refName, ids, membros) {
            const ref = this.$refs[refName];
            if (!ref) {
                return;
            }
            const lista = Array.isArray(ids) ? [...ids] : [];
            if (typeof ref.cacheSelectedItems === 'function' && Array.isArray(membros)) {
                const itens = membros
                    .filter((m) => m && lista.includes(m.id_usuario))
                    .map((m) => ({ ...m, displayText: this.montarDisplayTextUsuario(m) }));
                if (itens.length) {
                    ref.cacheSelectedItems(itens, 'id_usuario');
                }
            }
            if (typeof ref.setSelectedItems === 'function') {
                ref.setSelectedItems(lista);
            }
        },
        limparSelecaoUsuarios() {
            ['supervisorSelect', 'dispatcherSelect', 'usuariosSelect'].forEach((refName) => {
                const ref = this.$refs[refName];
                if (ref && typeof ref.resetData === 'function') {
                    ref.resetData();
                }
            });
        },
        close() {
            this.dialog = false;
            this.loadingUsuariosEquipe = false;
            this.limparSelecaoUsuarios();
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.usuariosEquipe = [];
                this.supervisorSelected = [];
                this.dispatcherSelected = [];
                this.membrosEquipe = [];
            });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
            });
        },
        populaUsuariosEquipe() {
            if (!this.editedItem.id_equipe) {
                return;
            }
            this.loadingUsuariosEquipe = true;
            apiController.request(apiController.endpoints.getUsuariosporequipe, {
                params: { id: this.editedItem.id_equipe },
                onSuccess: (response) => {
                    const membros = Array.isArray(response.data) ? response.data : [];
                    this.membrosEquipe = membros;
                    const porTipo = (tipo) => membros
                        .filter(u => Number(u.id_tipo_usuario) === tipo)
                        .map(u => u.id_usuario);
                    this.usuariosEquipe = porTipo(0);
                    this.supervisorSelected = porTipo(1);
                    this.dispatcherSelected = porTipo(2);
                    this.$nextTick(() => {
                        this.aplicarSelecaoUsuarios('supervisorSelect', this.supervisorSelected, membros);
                        this.aplicarSelecaoUsuarios('dispatcherSelect', this.dispatcherSelected, membros);
                        this.aplicarSelecaoUsuarios('usuariosSelect', this.usuariosEquipe, membros);
                    });
                    this.loadingUsuariosEquipe = false;
                },
                onError: () => {
                    this.loadingUsuariosEquipe = false;
                },
            });
        },
        editItem(item) {
            this.editedIndex = this.equipes.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
            this.operacao = 1;
            this.dialog = true;
            this.populaUsuariosEquipe();
        },
        deleteItem(item) {
            this.deletedItem = Object.assign({}, item);
            this.operacao = 2;
            this.mensagemdialog = this.$t('teams.confirmation.delete', { name: this.deletedItem.nome_equipe });
            this.messageConfirmButton = this.$t('button.delete');
            this.messageDismissButton = this.$t('button.dismiss');
            this.showConfirmButton = true;
            this.confirmDialog = true;
        },
        deleteFromDatabase() {
            apiController.request(apiController.endpoints.deleteEquipe, {
                data: this.deletedItem,
                onSuccess: (response) => {
                    this.updateTable(response.data.erro);
                    this.confirmDialog = false;
                },
                onError: () => {
                    this.confirmDialog = false;
                },
            });
        },
        save() {
            this.$refs.form.validate();
            if (this.formValidado) {
                // Convert boolean to int for API
                const payload = {
                    ...this.editedItem,
                    ativo: this.editedItem.ativo ? 1 : 0
                };
                
                if (this.editedIndex == -1) {
                    this.operacao = 0;
                    apiController.request(apiController.endpoints.createEquipe, {
                        data: payload,
                        onSuccess: (response) => {
                            console.log(response.data);
                            const insertId = response.data.insertId;
                            if (insertId && (this.usuariosEquipe.length > 0 || (this.supervisorSelected && this.supervisorSelected.length > 0) || (this.dispatcherSelected && this.dispatcherSelected.length > 0))) {
                                this.associarUsuariosEquipe(insertId);
                            } else {
                                this.updateTable(response.data.erro);
                            }
                        },
                    });
                } else {
                    this.operacao = 1;
                    apiController.request(apiController.endpoints.updateEquipe, {
                        data: payload,
                        onSuccess: (response) => {
                            console.log(response.data);
                            this.associarUsuariosEquipe(this.editedItem.id_equipe);
                        },
                    });
                }
            }
        },
        associarUsuariosEquipe(idEquipe) {
            // Build associations array: [id_equipe, id_usuario, id_tipo_usuario]
            const associacoes = [];
            
            // Add supervisors if selected
            if (this.supervisorSelected && this.supervisorSelected.length > 0) {
                this.supervisorSelected.forEach(idSupervisor => {
                    associacoes.push([idEquipe, idSupervisor, 1]);
                });
            }
            
            // Add dispatchers if selected
            if (this.dispatcherSelected && this.dispatcherSelected.length > 0) {
                this.dispatcherSelected.forEach(idDispatcher => {
                    associacoes.push([idEquipe, idDispatcher, 2]);
                });
            }
            
            // Add regular members (excluding supervisors and dispatchers if already added)
            this.usuariosEquipe.forEach(idUsuario => {
                const isSupervisor = this.supervisorSelected && this.supervisorSelected.includes(idUsuario);
                const isDispatcher = this.dispatcherSelected && this.dispatcherSelected.includes(idUsuario);
                if (!isSupervisor && !isDispatcher) {
                    associacoes.push([idEquipe, idUsuario, 0]);
                }
            });
            
            // First, remove all existing associations
            apiController.request(apiController.endpoints.desassociaRusuariosbulk, {
                data: { id_equipe: idEquipe },
                onSuccess: () => {
                    if (associacoes.length > 0) {
                        apiController.request(apiController.endpoints.associaRusuariosbulk, {
                            data: { associacoes: associacoes },
                            onSuccess: (response) => {
                                console.log(response.data);
                                this.updateTable(response.data.erro);
                            },
                        });
                    } else {
                        this.updateTable(false);
                    }
                },
            });
        },
        updateTable(status) {
            if (status) {
                if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('teams.error.create'), tipo: 'error' });
                } else if (this.operacao == 1) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('teams.error.update'), tipo: 'error' });
                } else {
                    EventBus.$emit('show-alert', { mensagem: this.$t('teams.error.delete'), tipo: 'error' });
                }
            } else {
                if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('teams.alerts.success.create'), tipo: 'success' });
                } else if (this.operacao == 1) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('teams.alerts.success.update'), tipo: 'success' });
                } else {
                    EventBus.$emit('show-alert', { mensagem: this.$t('teams.alerts.success.delete'), tipo: 'success' });
                }
                this.close();
                this.initialize();
            }
        },
    },
}
</script>

